import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDamageArea]'
})
export class DamageDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
